module.exports = __webpack_public_path__ + "img/logo1 (44).b5b6b9c6.jpg";